import { EProductType } from 'core/model/enums/product.enum';
import { shoppingCartService } from 'core/services/shopping-cart/shopping-cart.service';
import type { TSliceExtraReducer } from 'core/store';
import { getCustomerIdFromCheckout } from 'core/store/checkout/checkout-state.utils';
import { createAppAsyncThunk } from 'core/store/store.utils';
import { getCustomerIdByProductSource } from '../cart-state.utils';
import { SLICE_NAMESPACE } from '../constants';
import { ICartState } from '../types';

export const removeProductAction = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/removeProductAction`,
  async ({ sku, sourceId }: { sku: string; sourceId: EProductType }, { getState }) => {
    const { checkout, auth } = getState();
    const checkoutCustomerId = getCustomerIdFromCheckout(checkout);
    const customerIdByProductSource = getCustomerIdByProductSource(auth.customer, sourceId);
    const customerId = customerIdByProductSource || checkoutCustomerId;
    await shoppingCartService.deleteProductShoppingCart(sku, customerId);
  },
);

export const removeProductReducer: TSliceExtraReducer<ICartState> = builder => {
  builder
    .addCase(removeProductAction.pending, (state, { meta }) => {
      state.productsLoading = [...state.productsLoading, meta.arg.sku];
    })
    .addCase(removeProductAction.fulfilled, (state, { meta }) => {
      state.productsLoading = state.productsLoading.filter(pc => pc !== meta.arg.sku);
    })
    .addCase(removeProductAction.rejected, (state, { meta }) => {
      state.productsLoading = state.productsLoading.filter(pc => pc !== meta.arg.sku);
    });

  return builder;
};
